import {AsyncPipe, TitleCasePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltip} from '@angular/material/tooltip';
import {Router, RouterLink} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {AuthService} from '@app/auth/auth.service';

import {PreferencesDialogComponent} from '@app/preferences/preferences-dialog/preferences-dialog.component';
import {IdenticonPipe} from '@app/shared/identicon.pipe';
import {User} from '@app/shared/user.service';

import {Observable} from 'rxjs';

@Component({
    selector: 'frog-site-menu',
    templateUrl: './site-menu.component.html',
    styleUrls: ['./site-menu.component.scss'],
    imports: [
        MatButton,
        MatMenuTrigger,
        MatTooltip,
        MatIcon,
        MatMenu,
        MatMenuItem,
        RouterLink,
        AsyncPipe,
        TitleCasePipe,
        IdenticonPipe,
    ],
})
export class SiteMenuComponent implements OnInit {
    public user$: Observable<User>;
    public client$: Observable<Client>;

    constructor(
        private clientService: ClientService,
        private authService: AuthService,
        private matDialog: MatDialog,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.user$ = this.authService.user;
        this.client$ = this.clientService.client;
    }

    editPreferences() {
        this.matDialog.open(PreferencesDialogComponent, {
            maxWidth: '900px',
            width: '100%',
        });
    }

    logout() {
        this.authService.logout().subscribe();
    }
}
